// PDFPagination.js
import { Pagination } from "antd";

const PDFPagination = ({ totalItems, currentPage, onPageChange }) => (
  <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
    <Pagination
      current={currentPage + 1}
      defaultCurrent={1}
      total={totalItems}
      pageSize={10}
      onChange={(page) => onPageChange(page - 1)}
      showSizeChanger={false}
    />
  </div>
);

export default PDFPagination;
